import type { SVGProps } from 'react';

export function BrainIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.9 4.5c0-1.159.941-2.1 2.1-2.1h.9c.664 0 1.2.536 1.2 1.2v16.8c0 .664-.536 1.2-1.2 1.2H8.7a2.4 2.4 0 0 1-2.325-1.8H6.3A3 3 0 0 1 3.9 15a3 3 0 0 1-1.2-2.4c0-1.159.66-2.168 1.62-2.666A3 3 0 0 1 6.9 5.4zm10.2 0v.9a3 3 0 0 1 2.58 4.534A3 3 0 0 1 21.3 12.6c0 .982-.473 1.852-1.2 2.4a3 3 0 0 1-2.4 4.8h-.075a2.4 2.4 0 0 1-2.325 1.8h-1.2c-.664 0-1.2-.536-1.2-1.2V3.6c0-.664.536-1.2 1.2-1.2h.9c1.159 0 2.1.941 2.1 2.1" />
    </svg>
  );
}
